import { render, staticRenderFns } from "./ViewOtrsFaq.vue?vue&type=template&id=884cc2d6"
import script from "./ViewOtrsFaq.vue?vue&type=script&lang=js"
export * from "./ViewOtrsFaq.vue?vue&type=script&lang=js"
import style0 from "./ViewOtrsFaq.vue?vue&type=style&index=0&id=884cc2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports